import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import types from 'prop-types';
import momentTypes from 'react-moment-proptypes';
import { nonNegativeInteger } from 'airbnb-prop-types';
import moment from 'moment';
import { compose, branch, toClass, onlyUpdateForKeys } from 'recompose';
import { styled } from '@rexlabs/styling';
import styles from '../styles/calendar-month-grid';
import CalendarMonth from './calendar-month';
import getTransformStyles from '../utils/getTransformStyles';
import getCalendarMonthWidth from '../utils/getCalendarMonthWidth';
import toISOMonthString from '../utils/toISOMonthString';
import ScrollableOrientationShape from '../shapes/ScrollableOrientationShape';
import DayOfWeekShape from '../shapes/DayOfWeekShape';
import { HORIZONTAL_ORIENTATION, VERTICAL_SCROLLABLE, DAY_SIZE } from '../constants';
var assign = _Object$assign;

var getMonths = function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
  var month = initialMonth.clone();
  if (!withoutTransitionMonths) month = month.subtract(1, 'month');
  var months = [];

  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    months.push(month);
    month = month.clone().add(1, 'month');
  }

  return months;
};

var CalendarMonthGrid = function CalendarMonthGrid(_ref) {
  var _styles$with;

  var initialMonth = _ref.initialMonth,
      enableOutsideDays = _ref.enableOutsideDays,
      firstVisibleMonthIndex = _ref.firstVisibleMonthIndex,
      isAnimating = _ref.isAnimating,
      modifiers = _ref.modifiers,
      numberOfMonths = _ref.numberOfMonths,
      monthFormat = _ref.monthFormat,
      orientation = _ref.orientation,
      transformValue = _ref.transformValue,
      daySize = _ref.daySize,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onClick = _ref.onClick,
      renderMonth = _ref.renderMonth,
      renderDay = _ref.renderDay,
      onMonthTransitionEnd = _ref.onMonthTransitionEnd,
      firstDayOfWeek = _ref.firstDayOfWeek,
      focusedDate = _ref.focusedDate,
      isFocused = _ref.isFocused,
      setRef = _ref.setRef,
      dateIsUnavailableLabel = _ref.dateIsUnavailableLabel,
      Container = _ref.Container,
      styles = _ref.styles,
      monthPadding = _ref.monthPadding;
  var months = getMonths(initialMonth, numberOfMonths, orientation === VERTICAL_SCROLLABLE);
  var calendarMonthWidth = getCalendarMonthWidth(daySize, monthPadding);
  var width = orientation !== HORIZONTAL_ORIENTATION ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;
  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: setRef
  }, styles.with((_styles$with = {
    container: true
  }, _defineProperty(_styles$with, orientation, true), _defineProperty(_styles$with, "animating", isAnimating), _styles$with))(_objectSpread(_objectSpread({}, getTransformStyles(transformValue)), {}, {
    width: width
  })), {
    onTransitionEnd: onMonthTransitionEnd
  }), _mapInstanceProperty(months).call(months, function (month, i) {
    var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
    var monthString = toISOMonthString(month);
    return /*#__PURE__*/React.createElement(CalendarMonth, {
      key: monthString,
      month: month,
      isVisible: isVisible,
      enableOutsideDays: enableOutsideDays,
      modifiers: modifiers[monthString],
      monthFormat: monthFormat,
      orientation: orientation,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onClick: onClick,
      renderMonth: renderMonth,
      renderDay: renderDay,
      firstDayOfWeek: firstDayOfWeek,
      daySize: daySize,
      focusedDate: isVisible ? focusedDate : undefined,
      isFocused: isFocused,
      dateIsUnavailableLabel: dateIsUnavailableLabel
    });
  }));
};

var meta = {
  displayName: 'CalendarMonthGrid',
  propTypes: {
    enableOutsideDays: types.bool,
    firstVisibleMonthIndex: types.number,
    initialMonth: momentTypes.momentObj,
    isAnimating: types.bool,
    numberOfMonths: types.number,
    modifiers: types.object,
    orientation: ScrollableOrientationShape,
    onClick: types.func,
    onMouseEnter: types.func,
    onMouseLeave: types.func,
    onMonthTransitionEnd: types.func,
    setRef: types.func,
    renderMonth: types.func,
    renderDay: types.func,
    transformValue: types.string,
    daySize: nonNegativeInteger,
    focusedDate: momentTypes.momentObj,
    isFocused: types.bool,
    firstDayOfWeek: DayOfWeekShape,
    monthFormat: types.string,
    dateIsUnavailableLabel: types.string,
    Container: types.oneOfType([types.string, types.func])
  },
  defaultProps: {
    enableOutsideDays: false,
    firstVisibleMonthIndex: 0,
    initialMonth: moment(),
    isAnimating: false,
    numberOfMonths: 1,
    modifiers: {},
    orientation: HORIZONTAL_ORIENTATION,
    onClick: function onClick() {},
    onMouseEnter: function onMouseEnter() {},
    onMouseLeave: function onMouseLeave() {},
    onMonthTransitionEnd: function onMonthTransitionEnd() {},
    transformValue: 'none',
    daySize: DAY_SIZE,
    isFocused: false,
    monthFormat: 'MMMM YYYY',
    Container: 'div'
  }
};

var _CalendarMonthGrid = assign(branch(function (_ref2) {
  var setRef = _ref2.setRef;
  return !!setRef;
}, toClass)(CalendarMonthGrid), meta);

export default assign(compose(onlyUpdateForKeys(['initialMonth', 'numberOfMonths', 'orientation', 'month', 'isAnimating', 'modifiers', 'firstVisibleMonthIndex', 'focusedDate', 'isFocused']), styled(styles))(_CalendarMonthGrid), meta);